module.exports = __webpack_public_path__ + "img/translation-csv-hint.ad08aad6.png";